export const key = {
	customerName: 'ogm:customername',
	customerId: 'ogm:customerid',
	customerAttributes: 'ogm:customerattributes',
	userId: 'ogm:userid',
	externalId: 'ogm:externalid',
	roles: 'ogm:roles',
	preferences: 'ogm:preferences',
	expiresAt: 'ogm:expiresat',
	expiresIn: 'ogm:expiresin',
	customerCount: 'ogm:customercount',
	userDefaultPageSize: 'ogm:userDefaultPageSize',
	isSingleSignOn: 'ogm:isSingleSignOn',
	tier: 'ogm:tier',
	showOnlyAdditionalCoverage: 'ogm:showOnlyAdditionalCoverage',
	showEstNetPrice: 'ogm:showEstNetPrice',
	showProductAttributes: 'ogm:showProductAttributes',
	showWeightInOunces: 'ogm:showWeightInOunches',
	userProfileId: 'ogm:userProfileId',
	dontShowAddAndOptimizeWarningModal: 'ogm:dontShowAddAndOptimizeWarningModal',
};

export const expiresInDefaultValue = 180000;

export function getUserId(): number {
	return +window.localStorage.getItem(key.userId);
}

export function getCustomerId(): number {
	return +window.localStorage.getItem(key.customerId);
}

export function getShowOnlyAdditionalCoverage(): boolean {
	const showOnlyAdditionalCoverage = window.localStorage.getItem(
		key.showOnlyAdditionalCoverage
	);
	return (
		showOnlyAdditionalCoverage != null &&
		showOnlyAdditionalCoverage.toUpperCase() === 'TRUE'
	);
}

export function setShowOnlyAdditionalCoverage(
	showOnlyAdditionalCoverage: boolean
) {
	window.localStorage.setItem(
		key.showOnlyAdditionalCoverage,
		showOnlyAdditionalCoverage ? 'TRUE' : 'FALSE'
	);
}

export function getShowEstNetPrice(): boolean {
	const showEstNetPrice = window.localStorage.getItem(key.showEstNetPrice);
	return showEstNetPrice != null && showEstNetPrice.toUpperCase() === 'TRUE';
}

export function setShowEstNetPrice(showEstNetPrice: boolean) {
	window.localStorage.setItem(
		key.showEstNetPrice,
		showEstNetPrice ? 'TRUE' : 'FALSE'
	);
}

export function getShowProductAttributes(): boolean {
	const showProductAttributes = window.localStorage.getItem(
		key.showProductAttributes
	);
	return (
		showProductAttributes != null &&
		showProductAttributes.toUpperCase() === 'TRUE'
	);
}

export function setShowProductAttributes(showProductAttributes: boolean) {
	window.localStorage.setItem(
		key.showProductAttributes,
		showProductAttributes ? 'TRUE' : 'FALSE'
	);
}

export function getShowWeightInOunces(): boolean {
	const showWeightInOunces = window.localStorage.getItem(
		key.showWeightInOunces
	);
	return (
		showWeightInOunces != null && showWeightInOunces.toUpperCase() === 'TRUE'
	);
}

export function setShowWeightInOunces(showWeightInOunces: boolean) {
	window.localStorage.setItem(
		key.showWeightInOunces,
		showWeightInOunces ? 'TRUE' : 'FALSE'
	);
}

export function getDontShowAddAndOptimizeWarningModal(): boolean {
	const dontShowAddAndOptimizeWarningModal = window.localStorage.getItem(
		key.dontShowAddAndOptimizeWarningModal
	);
	return (
		dontShowAddAndOptimizeWarningModal != null &&
		dontShowAddAndOptimizeWarningModal.toUpperCase() === 'TRUE'
	);
}

export function setDontShowAddAndOptimizeWarningModal(
	showAddAndOptimizeWarningModal: boolean
) {
	window.localStorage.setItem(
		key.dontShowAddAndOptimizeWarningModal,
		showAddAndOptimizeWarningModal ? 'TRUE' : 'FALSE'
	);
}

export function hasAccessToMultipleCustomers(): boolean {
	return +window.localStorage.getItem(key.customerCount) > 1;
}

export function isSingleSignOnUser(): boolean {
	const isSingleSignOn = window.localStorage.getItem(key.isSingleSignOn);

	return isSingleSignOn != null && isSingleSignOn.toUpperCase() === 'TRUE';
}

export function getTier(): string {
	return window.localStorage.getItem(key.tier);
}
